<template>
  <OptionsList class="py-4" :active="active" :select="select" :options="sortOptions" />
</template>

<script setup>
import OptionsList from "@/pages/ListingsPage/filters/mobile/OptionsList.vue"
import ListingFilters from "@/lib/ListingFilters"

const { optionLabels, options } = defineProps({
  options: {
    type: Array,
    required: true,
  },
  optionLabels: {
    type: Object,
    required: false,
  },
})

const labelMap = optionLabels || ListingFilters.sortLabelMap()

const sortOptions = options.map((el) => ({ ...el, title: labelMap[el], value: el }))
</script>

<script>
import { mapActions, mapState } from "vuex"

export default {
  name: "SortFilter",
  methods: {
    active(value) {
      return this.selected == value
    },
    close() {
      if (typeof this.$parent.close === "function") {
        this.$parent.close()
      }
    },
    select(sortValue) {
      this.setFilter({ filterType: "sort", filter: sortValue })
      this.close()
    },
    ...mapActions("filter", ["setFilter"]),
  },
  computed: {
    ...mapState("filter", {
      selected: (state) => state.filters.sort,
    }),
  },
}
</script>
